import {
  CONSTRAINT_LIST_GET_SUCCESS,
  CONSTRAINT_GET_SUCCESS,
  CONSTRAINT_CREATE_SUCCESS,
  CONSTRAINT_UPDATE_SUCCESS,
  CONSTRAINT_UPDATE_ERROR,
  CONSTRAINT_DELETE_SUCCESS,
  CONSTRAINT_DELETE_ERROR,
  CONSTRAINT_LIST_GET_REQUEST,
  CONSTRAINT_LIST_GET_IN_PROGRESS,
  CONSTRAINT_LIST_GET_ERROR,
} from 'src/store/constraint/actions'
import { getIdsFromList, getByIdFromList } from 'src/utils/store'

export const getInitialState = {
  status: null,
  data: null,
  error: null,
  byId: null,
  statusById: null,
  errorById: null,
}

export const reducer = (state = getInitialState, action) => {
  const { type, payload } = action
  const { uuid } = typeof payload === 'string' ? payload : payload || {}

  switch (type) {
    case CONSTRAINT_LIST_GET_REQUEST:
    case CONSTRAINT_LIST_GET_IN_PROGRESS:
    case CONSTRAINT_LIST_GET_ERROR:
      return {
        ...state,
        status: type,
      }
    case CONSTRAINT_LIST_GET_SUCCESS:
      return {
        ...state,
        status: type,
        data: getIdsFromList(payload),
        byId: getByIdFromList(payload),
        statusById: getIdsFromList(payload).reduce(
          (status, id) => ({
            ...status,
            [id]: type,
          }),
          {}
        ),
        errorById: {},
      }
    case CONSTRAINT_GET_SUCCESS: {
      const { data, byId, statusById, ...restState } = state
      return {
        ...restState,
        data: data.indexOf(uuid) > -1 ? data : [...data, uuid],
        byId: {
          ...byId,
          [uuid]: payload,
        },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case CONSTRAINT_CREATE_SUCCESS: {
      const { data, byId, statusById, ...restState } = state
      return {
        ...restState,
        data: [...data, uuid],
        byId: {
          ...byId,
          [uuid]: payload,
        },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case CONSTRAINT_UPDATE_SUCCESS: {
      const { byId, statusById, ...restState } = state
      return {
        ...restState,
        byId: {
          ...byId,
          [uuid]: payload,
        },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case CONSTRAINT_UPDATE_ERROR: {
      const { statusById, errorById, ...restState } = state
      return {
        ...restState,
        statusById: {
          ...statusById,
          [uuid]: type,
        },
        errorById: {
          ...errorById,
          [uuid]: payload,
        },
      }
    }
    case CONSTRAINT_DELETE_SUCCESS: {
      const { data, byId, statusById, ...restState } = state
      delete byId[uuid]
      return {
        ...restState,
        data: data.filter((id) => id !== uuid),
        byId: { ...byId },
        statusById: {
          ...statusById,
          [uuid]: type,
        },
      }
    }
    case CONSTRAINT_DELETE_ERROR: {
      const { statusById, errorById, ...restState } = state
      return {
        ...restState,
        statusById: {
          ...statusById,
          [uuid]: type,
        },
        errorById: {
          ...errorById,
          [uuid]: payload,
        },
      }
    }
    default:
      return state
  }
}

export default reducer
